import { supabase } from '@/integrations/supabase/client';

export interface WaitlistSubmitInput {
  email: string;
  source?: string;
  referrer?: string | null;
  utmSource?: string | null;
  utmMedium?: string | null;
  utmCampaign?: string | null;
  utmContent?: string | null;
  userAgent?: string | null;
}

export type WaitlistSubmitResult =
  | { ok: true; alreadyOnList: boolean }
  | { ok: false; reason: 'invalid_email' | 'unknown'; message: string };

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// Matches the waitlist_signups length CHECKs (20261101180000), so a long ad-click referrer
// is shortened instead of refusing the signup.
const clip = (value: string | null | undefined, max: number) =>
  value ? value.slice(0, max) : null;

export const waitlistService = {
  async submit(input: WaitlistSubmitInput): Promise<WaitlistSubmitResult> {
    const email = input.email.trim().toLowerCase();
    if (!EMAIL_RE.test(email)) {
      return { ok: false, reason: 'invalid_email', message: 'Please enter a valid email.' };
    }
    const { error } = await supabase.from('waitlist_signups').insert({
      email,
      source: input.source ?? 'discover_coming_soon',
      referrer: clip(input.referrer, 500),
      utm_source: clip(input.utmSource, 200),
      utm_medium: clip(input.utmMedium, 200),
      utm_campaign: clip(input.utmCampaign, 200),
      utm_content: clip(input.utmContent, 200),
      user_agent: clip(input.userAgent, 500),
    });
    if (error) {
      // 23505 = unique constraint violation; treat as "already on list" (UX parity).
      if (error.code === '23505') {
        return { ok: true, alreadyOnList: true };
      }
      return {
        ok: false,
        reason: 'unknown',
        message: error.message ?? 'Could not save your email.',
      };
    }
    return { ok: true, alreadyOnList: false };
  },
};
